const TYPES = {
  GET_BEACON_POST: 'GET_BEACON_POST',
  CREATE_BEACON_POST: 'CREATE_BEACON_POST',
  EDIT_BEACON_POST: 'EDIT_BEACON_POST',
  DELETE_BEACON_POST: 'DELETE_BEACON_POST'
};

export default TYPES;
